import { type MenuItemType } from "@/types";

export const menuItems: MenuItemType[] = [
  { slug: "overview", label: "", isTitle: true, children: [
    { url: "/", slug: "pages:Overview", label: "Overview", icon: "dashboard" },
  ] },
  { slug: "engage", label: "Engage", isTitle: true, children: [
    { url: "/engagement-requests", slug: "pages:engagement-requests", label: "Engagement requests", icon: "streamline-sharp:slide-show-play" },
    { url: "/find-doctors", slug: "pages:find-doctors", label: "Find doctors", icon: "users" },
  ] },
  { slug: "reach", label: "Reach", isTitle: true, children: [
    { url: "/events-broadcasts", slug: "pages:events-broadcasts", label: "Events & broadcasts", icon: "bi:play-btn" },
  ] },
  { slug: "operate", label: "Operate", isTitle: true, children: [
    { url: "/payments-compliance", slug: "pages:payments-compliance", label: "Payments & compliance", icon: "wallet" },
    { url: "/team-settings", slug: "pages:team-settings", label: "Team & settings", icon: "settings" },
  ] },
  { slug: "account", label: "Account", isTitle: true, children: [
    { url: "/profile", slug: "pages:profile", label: "Company profile", icon: "building" },
  ] },
];
